import { useTranslation } from 'react-i18next';

import * as St from './SaveEstimateSection.styles';

import { MinimumPurchaseNotification } from '~/UI/components/molecules/MinimumPurchaseNotification/MinimumPurchaseNotification';
import { useSmallJobs } from '~/core/hooks/useSmallJobs';
import EstimateAndStoreInformation from '~molecules/EstimateAndStoreInformation';
import SaveEstimationButtons from '~organisms/SaveEstimationButtons';

const SaveEstimateSection = () => {
  const { t } = useTranslation();

  const { useMinQtyAreaForPricing, smallJobMinimumArea } = useSmallJobs();

  return (
    <St.Container>
      <St.NotificationContainer>
        <MinimumPurchaseNotification
          useMinQtyAreaForPricing={useMinQtyAreaForPricing}
          smallJobMinimumArea={smallJobMinimumArea}
        />
      </St.NotificationContainer>
      <SaveEstimationButtons />
      <EstimateAndStoreInformation />
      <p>{t('ORDER_SUMMARY.ESTIMATE_SECTION.DISCLAIMER')}</p>
      <p>{t('ORDER_SUMMARY.ESTIMATE_SECTION.DISCLAIMER_EXPIRATION')}</p>
    </St.Container>
  );
};

export default SaveEstimateSection;
